import React, { useRef } from "react";
import { Link } from "react-router-dom";
import "./FeaturedWork.css";
import forward from '../../Assets/next-arrow.png'
import card1 from "../../Assets/card1.mp4";
import card4 from "../../Assets/card4.mp4";
import card5 from "../../Assets/card5.mp4"; 

const projects = [
  {
    id: "01",
    title: "Calling All Cars",
    category: "Event Production / Film Production",
    year: "2026",
    image:
      "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?auto=format&fit=crop&w=1400&q=85",
    video: card1,
    size: "large",
  },

  {
    id: "02",
    title: "ETOE Productions",
    category: "Film / Creative Direction",
    year: "2026",
    image:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=85",
    video: card4,
    size: "medium",
  },

  {
    id: "03",
    title: "Aarika Real Estate",
    category: "Video Production / Cinematography",
    year: "2026",
    image:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1400&q=85",
    video: card5,
    size: "medium",
  },
];
function FeaturedWork() {
  const headerRef = useRef(null);

  const handleHeaderMove = (e) => {
    const rect = headerRef.current.getBoundingClientRect();

    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    const y = ((e.clientY - rect.top) / rect.height - 0.5) * 2;

    headerRef.current.style.setProperty("--x", x);
    headerRef.current.style.setProperty("--y", y);
  };

  const handleHeaderLeave = () => {
    headerRef.current.style.setProperty("--x", 0);
    headerRef.current.style.setProperty("--y", 0);
  };

 const handleProjectMove = (e) => {
  const card = e.currentTarget;
  const button = card.querySelector(".project-view");

  if (!button) return;

  const rect = card.getBoundingClientRect();

  const x = (e.clientX - rect.left) / rect.width;
  const y = (e.clientY - rect.top) / rect.height;

  // Maximum movement
  const moveX = (x - 0.5) * 40; // ±20px
  const moveY = (y - 0.5) * 40; // ±20px

  button.style.opacity = "1";
  button.style.transform = `translate(calc(-50% + ${moveX}px), calc(-50% + ${moveY}px)) scale(1)`;
};

 const handleProjectLeave = (e) => {
  const button = e.currentTarget.querySelector(".project-view");

  if (!button) return;

  button.style.opacity = "0";
  button.style.transform =
    "translate(-50%, -50%) scale(0.8)";
};

  return (
    <section
      className="featured-work"
      id="work"
    >
      <div className="featured-work-container">

        {/* HEADER */}

        <div
          className="featured-work-header"
          ref={headerRef}
          onMouseMove={handleHeaderMove}
          onMouseLeave={handleHeaderLeave}
        >
          <div className="featured-work-heading">

            <span className="featured-work-label">
              SELECTED WORK
            </span>

            <h2 className="featured-work-title">
              WORK THAT
              <span>MOVES BRANDS</span>
            </h2>

          </div>

          <div className="featured-work-intro">
            <p>
              Take a look at the projects we've created to help businesses build their brand, reach more customers, and grow successfully
            </p>
          </div>

        </div>

        {/* PROJECT GRID */}

        <div className="featured-work-grid">

          {projects.map((project) => (

            <article
  key={project.id}
  className={`project-card project-card-${project.size}`}
>
  <Link
    to={`/work/${project.id}`}
    className="project-card-link"
    onMouseMove={handleProjectMove}
    onMouseLeave={handleProjectLeave}
  >

    <div className="project-media">

      <img
        src={project.image}
        alt={project.title}
        className="project-image"
      />

      <div className="project-overlay" />

      <span className="project-number">
        {project.id}
      </span>

      <div className="project-view">
        <span className="project-view-label">
          VIEW PROJECT
        </span>

        <span className="project-view-arrow ">
          <img src={forward} alt="arrow"  className="cta-arrow"/>
        </span>
      </div>

    </div>

    <div className="project-information">

      <div>
        <h3>{project.title}</h3>
        <p>{project.category}</p>
      </div>

      <span className="project-year">
        {project.year}
      </span>

    </div>

  </Link>
</article>

          ))}

        </div>

        {/* FOOTER */}

        <div className="featured-work-footer">

          <Link
            to="/work"
            className="featured-work-button"
          >
            <span>View All Projects</span>

           <img src={forward} alt="arrow" className="cta-arrow" />

          </Link>

        </div>

      </div>

    </section>
  );
}

export default FeaturedWork;